import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Whatsapp from "./ScrollToTopButton/Whatsapp";
import ScrollToTopButton from "./ScrollToTopButton/SrcollToTop";
import { OrganizationJsonLd } from "./Seo/JsonLd";
function Layout() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100dvh" }}>
      {!isDashboard && <OrganizationJsonLd />}
      {!isDashboard && <Header />}
      {!isDashboard && <Whatsapp />}
      {!isDashboard && <ScrollToTopButton />}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Outlet />
      </div>
      {!isDashboard && <Footer />}
    </div>
  );
}

export default Layout;
